export default __webpack_public_path__ + "static/media/Group 1489@2x.fb98abd8.png";